export { default, statusTagTypes, type StatusTagProps, type StatusTagType } from './StatusTag';
